
    import Vue from "vue";
    import Component from "vue-class-component";
    import { appEventBus } from "@/utilities/EventBus";
    import Utils from "@/utilities/Utils";
    import apiClient, { ISendRequestParameters } from "@/utilities/ApiClient";
    import * as toastr from "toastr";

    const defaultLayout = "visitor";

    import SignInDialogue from "@/vue/components/SignInDialogue.vue";

    @Component({
        components: { SignInDialogue }
    })
    export default class App extends Vue {

        private pendingApiParameters: ISendRequestParameters | null = null;

        mounted(): void {

// const emails = ["aaa@bbb.ccc", "dick splash <aaa@bbb.ccc>", "\"dick o'splasherty\" <dick@splash.ccc>", "  dick splash <aaa@bbb.ccc>", "short email <a@b.cc>", "dick splash <aaa@bbb>"];
// for (const email of emails) {
//     const result = Utils.parseMailbox(email);
//     console.log(`+++ parse ${email} = `, result);
// }

            // Prevent any XSS shenanigans by default
            toastr.options.escapeHtml = true;

            appEventBus.on("http-401", this.onHttp401);
            appEventBus.on("http-error", this.onHttpError);
            appEventBus.on("fetch-exception", this.onFetchException);
            appEventBus.on("fetch-failed-offline", this.onFetchFailedOffline);
        }

        onAuthenticated() {
            if (this.pendingApiParameters == null) {
                return;
            }
            apiClient.sendRequest(this.pendingApiParameters);
            this.pendingApiParameters = null;
        }

        onHttp401(event: CustomEvent<any>) {
            this.pendingApiParameters = event.detail as ISendRequestParameters;
            const dlg: SignInDialogue = this.$refs.signInDialogue as SignInDialogue;
            dlg.show();
        }

        onHttpError(event: CustomEvent<any>) {
            const response = event.detail as Response;
            const status = response.status;
            if (status === 500) {
                response.text().then(bodyText => {
                    // if we're running in production, we'll probably not get a response body - but handy to show in dev mode
                    if (bodyText) {
                        this.showErrorMessageWithContent("Server Error", "Status = " + response.status, bodyText);
                    }
                    else {
                        this.showErrorMessage("Server Error", "Status = " + response.status);
                    }
                });
            }
            else {
                this.showErrorMessage("HTTP Error", "Status = " + response.status);
            }
        }

        onFetchException(event: CustomEvent<any>) {
            const reason = event.detail;
            const message = typeof reason === "string"
                ? reason
                : (typeof reason === "object" && reason.message)
                    ? reason.message
                    : "Failed to communicate with server";
            this.showErrorMessage("API Error", message);
        }

        onFetchFailedOffline (event: CustomEvent<any>) {
            this.showErrorMessage("Network Problem", "Could not communicate with server.\n\nPlease check your network connection.");
        }

        // todo - how do we show a dialogue via code with vuetify
        showErrorMessageWithContent(title: string, message: string, content: string) {
            toastr.warning(message, title);
        }

        showErrorMessage(title: string, message: string) {
            toastr.warning(message, title);
        }

        // computed property used to select layout - see also main.ts
        get layout() {
            if (!this.$route.meta?.layout) return null;
            return (this.$route.meta?.layout || defaultLayout) + "-layout";
        }
    }
